module.exports = __webpack_public_path__ + "img/duplo-diamante.7b459d53.png";